export enum ActionTypes {
    READ = '1001',
    CREATE = '1002',
    UPDATE = '1003',
    DELETE = '1004',
    RESTORE = '1005',
    ADMIN_ASSIGN = '1006',
    GROUP_ROUTE_ASSIGN = '1007',
    ROUTE_ASSING = '1008',
    CHECKPOINT_ASSIGN = '1009',
    TURN_ASSING = '1010',
    MEDIUM_CONECTION_ASING='1011',
    SEND_EMAIL = '1012',
    HISTORIC = '1013',
    SCHEDULE_ASSING = '1014',
    GROUP_VEHICLE_ASSING = '1015',
    DISPATCH_ASSING = '1016',
    APPLICATION_VERSION = '1017',
    SEND_VEHICLE_APPLICATION_VERSION='1018',
    SECTOR_ASSING = '1019',
    FARE_ASSING = '1020',
    STOP_ASSIGN = '1021',
    GROUP_PASSENGER_ASSIGN = '1022',
    IDENTIER_ASSING = '1023',
    CONNECTION_MEDIUM_STOP_ASIGN = '1024',
    SITES_ASIGN = '1025',
    DEVICE_RECHARGE_ASIGN = '1026',
    ADD_DEPOSIT = '1027',
    PROJECT_STATUS_ASIGN = '1028',
    SYSTEM_CONFIGS = '1029',
    INCIDENCE_TIMES = '1030',
    PROJECT_REPORTS = '1031',
    BRAND_ASSING = '1032'
}